module.exports = global.config = {
  i18n: {
      welcome: {
          en: "Welcome",
          fa: "خوش آمدید"
      }
      // rest of your translation object
  },

  urlBase: "https://ven-validador-api-qa.zurcodesignio.com/validador"

  // other global config variables you wish
};